import React, { useContext, useState, useRef, useEffect } from "react";
import loginimg from "../Assets/Img/loginsideimg.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import axiosMain from "../http/axiosMain";
import { GlobalContext } from "../../utils/GlobalContext";

function SignUpWithOtp() {
  const { isLogdin, setisLogdin } = useContext(GlobalContext);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [timer, setTimer] = useState(60); // 60-second countdown
  const [canResend, setCanResend] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const inputsRef = useRef([]);

  // Handle OTP input change
  const handleChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      let newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to next input if a digit is entered
      if (value !== "" && index < otp.length - 1) {
        inputsRef.current[index + 1]?.focus();
      }
    }
  };

  // Handle key events (backspace, delete, and paste)
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0) {
        inputsRef.current[index - 1]?.focus();
      }
    }
  };

  
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setCanResend(true); // Allow resending after 30 seconds
    }
  }, [timer]);

  // Handle OTP paste
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    if (/^\d{6}$/.test(pastedData)) {
      setOtp(pastedData.split(""));
      inputsRef.current[5]?.focus(); // Move focus to last input
    }
  };

  // Validate and submit OTP
  const handleSubmit = async () => {
    const otpCode = otp.join("");
    const role = localStorage.getItem("userType");

    if (otpCode.length !== 6) {
      setError("Please enter a valid 6-digit OTP.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await axiosMain.post("/api/auth/verify-email-otp", {
        email: id,
        otp: otpCode,
        role: role,
      });

      if (response.data.isLoginSuccess) {
        setisLogdin(true);
        if (role === "brand") {
          navigate("/brand-home");
        } else if (role === "influencer") {
          navigate("/influencer-home");
        } else {
          setError("Invalid user role. Please try again.");
        }
      } else {
        setError(response.data.message || "Invalid OTP. Please try again.");
      }
    } catch (err) {
      setError(
        err.response?.data?.message || "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setCanResend(false);
    setTimer(60); // Restart the countdown
  
    try {
      await axiosMain.post("/api/auth/send-email-otp", { email: id });
  
      // Restart the countdown timer
      const interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setCanResend(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } catch (err) {
      setError("Failed to resend OTP. Please try again.");
      setCanResend(true);
    }
  };

  return (
    <div className="container-mobileotp p-0 mt-5 mb-5">
      <div className="card">
        <div className="row no-gutters">
          <div className="col-xs-12 col-sm-12 col-md-12 left">
            <img src={loginimg} alt="Login visual" className="img" />
          </div>

          <div className="col-xs-12 col-sm-12 col-md-12 right">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 text-center">
                <h2>
                  Collaborate.
                  <br /> Create. Connect.
                </h2>
                <div className="otp-input-fields">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      type="tel"
                      className="otp__digit"
                      maxLength={1}
                      value={digit}
                      ref={(el) => (inputsRef.current[index] = el)}
                      onChange={(e) => handleChange(index, e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      onPaste={handlePaste}
                    />
                  ))}
                </div>
                {error && <p className="text-danger">{error}</p>}
                <button
                  type="button"
                  className="btn btn-outline-success btn-lg mt-4"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? "Validating..." : "Validate and Log in"}
                </button>

                {/* Resend OTP Section */}
                <div className="mt-3">
                  <button
                    className="btn btn-outline-primary"
                    onClick={handleResendOtp}
                    disabled={!canResend}
                  >
                    {canResend ? "Resend OTP" : `Resend OTP in ${timer}s`}
                  </button>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 footer">
                <Link to="/login" className="btn-link">
                  Log In with Email
                </Link>
                <div className="signup-instruction">
                  By continuing, you agree to our terms and conditions.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUpWithOtp;
